import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const ProgramTypeGreenIcon = ({ label = 'ProgramTypeGreen', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><rect x="103.3" y="51.4" width="126.6" height="152.57" rx="5" style="fill:#b1ce5f"/><path d="M225 56.4v142.5H108.3V56.4H225m0-10H108.3a10 10 0 0 0-10 10v142.5a10 10 0 0 0 10 10H225a10 10 0 0 0 10-10V56.4a10 10 0 0 0-10-10z" style="fill:#1d1d1b"/><path d="M233.1 237.8a4.9 4.9 0 0 1 4.8 4.9v3.2a4.9 4.9 0 0 1-4.8 4.9H88.9a32.4 32.4 0 0 1-32.4-32.4V75.8a32.4 32.4 0 0 1 32.4-32.4h139.3a9.6 9.6 0 0 1 9.7 9.7v149.1a9.9 9.9 0 0 1-6 9c-1.5 6.5-1.8 18.4-.2 26.6zm-12.9-25.9H88.9c-25.9 0-25.9 25.9 0 25.9h131.3a93.6 93.6 0 0 1 0-25.9zm-131.3-13h6.5V56.4h-6.5a19.4 19.4 0 0 0-19.5 19.4v129.6a33.1 33.1 0 0 1 19.5-6.5zm136.1 0V56.4H108.3v142.5zm-92.4-90.7a4.8 4.8 0 0 1-4.8-4.8v-3.3a4.7 4.7 0 0 1 4.8-4.8h68.1a4.8 4.8 0 0 1 4.8 4.8v3.3a4.9 4.9 0 0 1-4.8 4.8zm68.1 25.9h-68.1a4.8 4.8 0 0 1-4.8-4.8V126a4.8 4.8 0 0 1 4.8-4.8h68.1a4.9 4.9 0 0 1 4.8 4.8v3.3a4.9 4.9 0 0 1-4.8 4.8z"/></svg>`}
    />
  )
}

ProgramTypeGreenIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { ProgramTypeGreenIcon }
